export default __webpack_public_path__ + "static/alexey-9c3a41b092eb8f38c16f8d3bda28ba73.jpeg";